export class SystemUserRoles {
    public static readonly ADMIN: number = 1;
    public static readonly MANAGER: number = 2;
    public static readonly SUPERVISOR: number = 3;
    public static readonly AGENT: number = 4;
    public static readonly CLIENT: number = 5;

    public static readonly ADMIN_NAME: string = 'Admin';
    public static readonly MANAGER_NAME: string = 'Manager';
    public static readonly SUPERVISOR_NAME: string = 'Supervisor';
    public static readonly AGENT_NAME: string = 'Agent';
    public static readonly CLIENT_NAME: string = 'Client';

    public static readonly ALL = [SystemUserRoles.ADMIN_NAME,
    SystemUserRoles.MANAGER_NAME,
    SystemUserRoles.SUPERVISOR_NAME,
    SystemUserRoles.AGENT_NAME,
    SystemUserRoles.CLIENT_NAME]
}
